import { Badge } from './ui/badge';
import { Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function BlackFridayBadge({ className = '', onClick }) {
  const navigate = useNavigate();
  
  // Black Friday period: November 28 - December 1
  const currentYear = new Date().getFullYear();
  const BLACK_FRIDAY_START = new Date(`${currentYear}-11-28T00:00:00`);
  const BLACK_FRIDAY_END = new Date(`${currentYear}-12-01T23:59:59`);
  const now = new Date();
  
  // Only show during Black Friday period (Nov 28 - Dec 1)
  const isBlackFridayPeriod = now >= BLACK_FRIDAY_START && now <= BLACK_FRIDAY_END;
  if (!isBlackFridayPeriod) return null;
  
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate('/black-friday-checkout');
    }
  };
  
  return (
    <Badge 
      onClick={handleClick}
      className={`bg-gradient-to-r from-yellow-400 to-orange-500 text-black font-bold animate-pulse hover:animate-none cursor-pointer hover:scale-105 transition-transform ${className}`}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
    >
      <Zap className="w-3 h-3 mr-1" />
      BLACK FRIDAY BOGO - Click Here!
    </Badge>
  );
}
